import { render, staticRenderFns } from "./_Detail.vue?vue&type=template&id=eb2b63b0&lang=pug&"
import script from "./_Detail.vue?vue&type=script&lang=js&"
export * from "./_Detail.vue?vue&type=script&lang=js&"
import style0 from "./_Detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports